/**
 * 来电振铃 触发
 */
import {MessageBox} from 'dygc-ui'
import { createPopup } from '@/assets/js/factory'
import Coming from '@/views/cati/c/Coming.vue'
import { getPhoneInfo } from '@/api/cati'
import Calling from '@/views/cati/c/Calling.vue'
import { setDelayFn } from '@/views/cati/fn'

export const createOnCallComing = (bus, params, cb) => {
  let vm = null
  return callDetail => {
    const callee = callDetail.callee
    if (vm) {
      return
    }
    vm = createPopup(Coming, {
      data: {}
    })
    // vm.setInfo({})

    const close = () => {
      if (!vm) return
      vm.$emit('close')
      vm = null
      bus.$off('onHangUp', close)
      bus.$off('answer', answer)
      bus.$off('onStatusChange', onStatusChange)
    }

    function onStatusChange({ code }) {
      if (code !== 6) {
        close()
      }
    }

    function answer(data) {
      close()
    }

    bus.$on('answer', answer)
    bus.$on('onStatusChange', onStatusChange)
    bus.$on('onHangUp', close)
    vm.$on('hangUp', () => {
      bus.hangUp()
      close()
    })

    vm.$on('coming', () => {
      const data = vm.getInfo()
      bus.onAnswer(data)
    })

    vm.loading = true
    vm.setInfo({
      phoneNumber: callDetail.callee
    })
    setDelayFn(getPhoneInfo(params.taskId, callDetail.callee).then(res => {
      const data = res.data.data
      if (res.data.code !== 0) {
        MessageBox.alert(res.data.msg)
        return
      }

      bus.setCurrentCall(data)
      bus.answerSuccess(data)
      cb && cb(data)

      if (vm) {
        vm.setInfo(data)
        vm.loading = false
      }
    }))
    // 先接听再获取信息
    bus.onlyAnswer()

  }
}
